import { render, staticRenderFns } from "./trialSuccess_tl8.vue?vue&type=template&id=70b650aa&scoped=true"
import script from "./trialSuccess_tl8.vue?vue&type=script&lang=js"
export * from "./trialSuccess_tl8.vue?vue&type=script&lang=js"
import style0 from "./trialSuccess_tl8.vue?vue&type=style&index=0&id=70b650aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b650aa",
  null
  
)

export default component.exports